<template>
    <ion-card class="floating floating-large">
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.settings_title') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner></ion-spinner>
            </div>
            <div v-else>
                <ion-list>
                    <settings-list-item v-for="(setting, key) in settings" v-bind:key="`${key}`" :setting="setting"
                                        :label="key"></settings-list-item>
                </ion-list>
                <br/>
                <ion-button @click="submit()">
                    <ion-icon ios='save' md="save" slot="start"></ion-icon>

                    {{ $t('ncrypt.save') }}
                </ion-button>
            </div>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {Notifier} from "@/services/Notifier";
    import {ApiError} from "@/errors/ApiError";
    import {SETTINGS_MUTATION} from "@/const/mutation-types";
    import SettingsListItem from "./SettingsListItem";

    export default {
        name: "CompanySettings",
        components: {
            SettingsListItem,
        },
        data() {
            return {
                settings: undefined,
                loading: true,
            };
        },
        methods: {
            saveData() {
                const saveData = {};

                Object.entries(this.settings)
                    .filter(([key, item]) => !item.inherited)
                    .forEach(([key, item]) => saveData[key] = item.value);

                return saveData;
            },
            async submit() {
                const loader = await this.$ionic.loadingController.create({
                    message: this.$t('ncrypt.details_are_being_saved'),
                    duration: 1000000,
                });

                await loader.present();

                this.$http.post('/account/company/settings-update', {
                    settings: this.saveData(),
                })
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.$store.commit(SETTINGS_MUTATION, data.combined_settings);

                        await Notifier.showToast({
                            message: this.$t('ncrypt.details_are_saved'),
                        })
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => loader.dismiss());
            },
        },
        async mounted() {
            this.loading = true;

            this.$http.get('/account/company/settings')
                .then(async ({data}) => {
                    if (!data) {
                        new ApiError(data);
                        return;
                    }

                    this.settings = data;
                })
                .catch(reason => new ApiError(reason))
                .finally(() => this.loading = false);
        },
    }
</script>
